// modules
import { createAction } from 'redux-actions'

// actions
export const setAgencyCaseManagementList = createAction(
  'SET_AGENCY_CASE_MANAGEMENT_LIST'
)
export const setAgencyCaseManagementEditItem = createAction(
  'SET_AGENCY_CASE_MANAGEMENT_EDIT_ITEM'
)

export const resetAgencyCaseManagement = createAction(
  'RESET_AGENCY_CASE_MANAGEMENT'
)
